<template>
  <VLayout v-if="selectedInvoice" row wrap>
    <VFlex xs6 xl6 style="border-right: solid 1px #e0e0e0; height: calc(100vh - 164px)">
      <Viewer
        id="dashboard-viewer"
        :file="selectedInvoice.file"
        :file-name="selectedInvoice.file_name"
        :mail-from="selectedInvoice.attachment.received_mail.from_mail"
        :mail-subject="selectedInvoice.attachment.received_mail.subject"
        :mail-date="selectedInvoice.attachment.received_mail.sent_date"
        @image-data="imageData = $event"
      >
        <template #fields>
          <konva-group v-if="vatIdBuyerTextBlock" ref="buyerBlock">
            <konva-rect
              :config="{
                id: 'buyerTextblock',
                x: vatIdBuyerTextBlock.x,
                y: vatIdBuyerTextBlock.y,
                width: vatIdBuyerTextBlock.width,
                height: vatIdBuyerTextBlock.height,
                stroke: 'red',
                strokeWidth: 3,
              }"
            />
          </konva-group>
        </template>
      </Viewer>
    </VFlex>
    <VFlex xs6 xl6>
      <VTabs v-model="tabsModel" color="#f5f5f5" slider-color="primary" height="64px" grow>
        <VTab key="invoice_data"> Podatki računa </VTab>
      </VTabs>
      <VTabsItems
        v-model="tabsModel"
        class="d-flex blurredLoading"
        :class="{ blurredLoadingActive: loadingData }"
        style="height: calc(100vh - 164px); position: absolute; overflow: auto"
      >
        <VTabItem :key="'invoice_data'" class="tab--item fill-height">
          <InvoiceTab
            v-if="!loadingDataError"
            :selected-invoice="selectedInvoice"
            @loadingData="loadingData = $event"
            @loadingDataError="loadingDataError = $event"
            @vat-id-buyer="vatIdBuyer = $event"
          />
          <h1 v-else style="margin: 30px">
            Napaka pri nalaganju podatkov: <br />
            {{ loadingDataError }}
          </h1>
        </VTabItem>
      </VTabsItems>
    </VFlex>
  </VLayout>
</template>
<script>
/* eslint-disable quote-props,no-unused-vars */
import { mapGetters, mapActions } from 'vuex';
import { findBestStringMatch } from '@/helper';
import Viewer from '@/components/preview/Viewer.vue';
import InvoiceTab from '../components/InvoiceTab.vue';

export default {
  components: {
    Viewer,
    InvoiceTab,
  },
  data() {
    return {
      tabsModel: null,
      loadingData: false,
      loadingDataError: '',
      vatIdBuyer: '',
      textBlockStrings: [],
      imageData: {
        width: 0,
        height: 0,
      },
      selectedInvoice: null,
    };
  },
  computed: {
    ...mapGetters(['activeInvoice', 'showNewVatCard']),
    vatIdBuyerTextBlock() {
      if (this.textBlockStrings.length && this.selectedInvoice.text_blocks) {
        const bestMatchIndex = findBestStringMatch(this.vatIdBuyer, this.textBlockStrings);
        const vatIdBuyerTextBlockObject = this.selectedInvoice.text_blocks[bestMatchIndex];
        const scalingWidth = this.imageData.width / vatIdBuyerTextBlockObject.doc_width;
        const scalingHeight = this.imageData.height / vatIdBuyerTextBlockObject.doc_height;
        return {
          x: vatIdBuyerTextBlockObject.x * scalingWidth,
          y: vatIdBuyerTextBlockObject.y * scalingHeight,
          width: vatIdBuyerTextBlockObject.width * scalingWidth,
          height: vatIdBuyerTextBlockObject.height * scalingHeight,
        };
      }
      return null;
    },
  },
  watch: {
    activeInvoice(value) {
      this.vatIdBuyer = '';
      this.textBlockStrings = [];
      this.loadingDataError = '';
      this.selectedInvoice = value;
      this.setTextBlockString(value);
    },
  },
  created() {
    this.$store.dispatch('setDrawerStateAction', true);
    this.getNextInvoiceForReview();
  },
  methods: {
    ...mapActions(['getNextInvoiceForReview', 'setSnackBarStateAction']),
    setTextBlockString(invoice) {
      if (invoice && invoice.text_blocks) {
        this.textBlockStrings =
          invoice.text_blocks.length > 0 ? invoice.text_blocks.map((tb) => tb.text) : [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.document_image {
  width: 50%;
  margin: 0 auto;
  display: block;
}

.product-title {
  overflow: hidden;
  text-overflow: ellipsis;
}
.tab--item {
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
}

.blurredLoading {
  filter: unset;
  transition: ease-out 0.5s;
}

.blurredLoadingActive {
  filter: blur(3px);
  pointer-events: none;
}
</style>
